import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { GLOBAL_DATE_VIEW_DEFAULT_FORMAT } from "../../../constants";

const DateCell = ({ value, format }) => {
  return (
    <div className="flex">
      <p className="truncate">{value ? moment(value).format(format) : ""}</p>
    </div>
  );
};

DateCell.propTypes = {
  value: PropTypes.string,
  format: PropTypes.string,
};

DateCell.defaultProps = {
  value: undefined,
  format: GLOBAL_DATE_VIEW_DEFAULT_FORMAT,
};

export default DateCell;
